import { createSlice } from '@reduxjs/toolkit'

export const urlInfoSlice = createSlice({
	name: 'urlInfo',
	initialState: {
		info: {
			url: '',
		},
	},
	reducers: {
		setUrlInfo: (state, action) => {
			console.log('action', action)
			console.log('state', state)
			state.info = action.payload
		},
	},
})

export const { setUrlInfo } = urlInfoSlice.actions
export default urlInfoSlice.reducer
export const selectUrl = (state: any) => state.urlInfo.info
